import { emailPattern, phonePattern, postalCodePattern } from "../appconfig/Settings";

// login validation
export const LoginValidate = (inputDetail: any) => {
  let isError: boolean = false;

  let errorObj: any = {};

  let errors: any = {};

  if (window.cn(inputDetail.email) && !window.cb(inputDetail.email)) {
    errors = { ...errors, email: "Enter Email *" };
    isError = true;
  } else if (!emailPattern.test(inputDetail.email)) {
    errors = { ...errors, email: "Enter Valid Email*" };
    isError = true;
  } else {
    errors = { ...errors, email: "" };
  }

  if (window.cn(inputDetail.password) && !window.cb(inputDetail.password)) {
    errors = { ...errors, password: "Enter Password *" };
    isError = true;
  } else {
    errors = { ...errors, password: "" };
  }

  errorObj = { errors, isError };

  return errorObj;
};

// user add validate
export const validateUserForm = (inputDetail: any) => {
  let errors: any = {};
  let isError = false;
  if (window.cn(inputDetail.first_name) && !window.cb(inputDetail.first_name)) {
    errors.first_name = "Enter First Name *";
    isError = true;
  }
  if (window.cn(inputDetail.last_name) && !window.cb(inputDetail.last_name)) {
    errors.last_name = "Enter Last Name *";
    isError = true;
  }
  if (window.cn(inputDetail.email) && !window.cb(inputDetail.email)) {
    errors.email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail.email)) {
    errors.email = "Enter Valid Email *";
    isError = true;
  }
  if (window.cn(inputDetail.phone) && !window.cb(inputDetail.phone)) {
    errors.phone = "Enter Phone *";
    isError = true;
  } else if (!phonePattern.test(inputDetail.phone)) {
    errors.phone = "Enter Valid Phone *";
    isError = true;
  }
  if (window.cn(inputDetail.postal_code) && !window.cb(inputDetail.postal_code)) {
    errors.postal_code = "Enter Postal Code *";
    isError = true;
  } else if (!postalCodePattern.test(inputDetail.postal_code)) {
    errors.postal_code = "Enter Valid Postal Code *";
    isError = true;
  }
  if (window.cn(inputDetail.address) && !window.cb(inputDetail.address)) {
    errors.address = "Enter Address *";
    isError = true;
  }
  return { errors, isError };
};

// section validation for user form
export const sectionValidations: Record<string, string[]> = {
  personal: ["name", "date_of_birth", "street_address", "city", "province", "postal_code", "email", "phone"],
  employment: [
    "sin_number",
    "income_from_home",
    "date_of_entry",
    "moving_date",
    "benefit_status",
    "province_from",
    "province_to",
    "first_time_form_filling_status",
  ],
  documents: ["t5008_file", "t4_file", "t5007_file", "t5_file"],
  marital: ["dec_marrige_status"],
};

// Employee add validate
export const validateEmployeeForm = (inputDetail: any, isEdit: any, menuPermissions: any) => {
  let errors: any = {};
  let isError = false;

  if (window.cn(inputDetail.first_name) && !window.cb(inputDetail.first_name)) {
    errors.first_name = "Enter First Name *";
    isError = true;
  }

  if (window.cn(inputDetail.last_name) && !window.cb(inputDetail.last_name)) {
    errors.last_name = "Enter Last Name *";
    isError = true;
  }

  if (window.cn(inputDetail.email) && !window.cb(inputDetail.email)) {
    errors.email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail.email)) {
    errors.email = "Enter Valid Email *";
    isError = true;
  }
  if (window.cn(inputDetail.postal_code) && !window.cb(inputDetail.postal_code)) {
    errors.postal_code = "Enter Postal Code *";
    isError = true;
  } else if (!postalCodePattern.test(inputDetail.postal_code)) {
    errors.postal_code = "Enter Valid Postal Code *";
    isError = true;
  }

  if (window.cn(inputDetail.joining_date) && !window.cb(inputDetail.joining_date)) {
    errors.joining_date = "Enter Joining Date *";
    isError = true;
  }
  if (window.cn(inputDetail.date_of_birth) && !window.cb(inputDetail.date_of_birth)) {
    errors.date_of_birth = "Enter Date of Birth *";
    isError = true;
  }

  if (window.cn(inputDetail.mobile_no) && !window.cb(inputDetail.mobile_no)) {
    errors.mobile_no = "Enter Phone *";
    isError = true;
  } else if (!phonePattern.test(inputDetail.mobile_no)) {
    errors.mobile_no = "Enter Valid Phone *";
    isError = true;
  }

  if (window.cn(inputDetail.city) && !window.cb(inputDetail.city)) {
    errors.city = "Enter City *";
    isError = true;
  }

  if (window.cn(inputDetail.address) && !window.cb(inputDetail.address)) {
    errors.address = "Enter Street Address *";
    isError = true;
  }

  if (!menuPermissions || menuPermissions.length === 0) {
    errors.menu_permissions = "Select at least one permission *";
    isError = true;
  }

  return { errors, isError };
};
export const validateTaxPayerForm = (inputDetail: any) => {
  let errors: any = {};
  let isError = false;

  if (window.cn(inputDetail.last_name) && !window.cb(inputDetail.last_name)) {
    errors.last_name = "Enter Last Name *";
    isError = true;
  }

  if (window.cn(inputDetail.email) && !window.cb(inputDetail.email)) {
    errors.email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail.email)) {
    errors.email = "Enter Valid Email *";
    isError = true;
  }

  if (window.cn(inputDetail.mobile) && !window.cb(inputDetail.mobile)) {
    errors.mobile = "Enter Phone *";
    isError = true;
  } else if (!phonePattern.test(inputDetail.mobile)) {
    errors.mobile = "Enter Valid Phone *";
    isError = true;
  }
  if (window.cn(inputDetail.dec_marrige_status) && !window.cb(inputDetail.dec_marrige_status)) {
    errors.dec_marrige_status = "Enter Marital Status *";
    isError = true;
  }
  if (
    inputDetail?.dec_marrige_status === "Married" ||
    inputDetail?.dec_marrige_status === "Living common-law"
  ) {
    // ✅ Updated condition: BOTH must be true
    if (
      inputDetail?.is_spouse_canadian_resident === "1" &&
      inputDetail?.file_spouse_tax === "true"
    ) {
      if (
        window.cn(inputDetail.spouse_email) &&
        !window.cb(inputDetail.spouse_email)
      ) {
        errors.spouse_email = "Please Enter Spouse Email *";
        isError = true;
      } else if (
        inputDetail.spouse_email &&
        !emailPattern.test(inputDetail.spouse_email)
      ) {
        errors.spouse_email = "Please Enter Valid Spouse Email *";
        isError = true;
      }
    } else {
      // Optional → validate only if filled
      if (
        window.cb(inputDetail.spouse_email) &&
        !emailPattern.test(inputDetail.spouse_email)
      ) {
        errors.spouse_email = "Please Enter Valid Spouse Email *";
        isError = true;
      }
    }

    if (
      window.cn(inputDetail.is_spouse_canadian_resident) &&
      !window.cb(inputDetail.is_spouse_canadian_resident)
    ) {
      errors.is_spouse_canadian_resident =
        "Please Select Spouse Canadian Resident*";
      isError = true;
    }

    // ✅ file_spouse_tax required ONLY if resident = 1
    if (inputDetail?.is_spouse_canadian_resident === "1") {
      if (
        window.cn(inputDetail.file_spouse_tax) &&
        !window.cb(inputDetail.file_spouse_tax)
      ) {
        errors.file_spouse_tax = "Please Select File Spouse Tax*";
        isError = true;
      }
    }
  }
  return { errors, isError };
};

// validate PAyrollForm
export const validatePayrollForm = (inputDetail: any) => {
  let errors: any = {};
  let isError = false;
  if (window.cn(inputDetail) && !window.cb(inputDetail)) {
    errors.hour = "Enter Working hour *";
    isError = true;
  }
  return { errors, isError };
};

// change password validate
export const ChangePasswordValidate = (inputDetail: any) => {
  let isError = false;
  const errors: any = {};

  if (window.cn(inputDetail.currentPassword) && !window.cb(inputDetail.currentPassword)) {
    errors.currentPassword = "Current Password is required *";
    isError = true;
  }
  if (window.cn(inputDetail.newPassword) && !window.cb(inputDetail.newPassword)) {
    errors.newPassword = "New Password is required *";
    isError = true;
  }
  if (window.cn(inputDetail.confirmPassword) && !window.cb(inputDetail.confirmPassword)) {
    errors.confirmPassword = "Confirm Password is required *";
    isError = true;
  } else if (inputDetail.newPassword && inputDetail.confirmPassword && inputDetail.newPassword !== inputDetail.confirmPassword) {
    errors.confirmPassword = "Passwords do not match *";
    isError = true;
  }
  return { errors, isError };
};

// holiday validation
export const HolidayValidate = (inputDetail: any) => {
  let isError = false;
  const errors: any = {};

  if (window.cn(inputDetail.name) && !window.cb(inputDetail.name)) {
    errors.name = "Holiday name is required *";
    isError = true;
  }
  if (window.cn(inputDetail.date) && !window.cb(inputDetail.date)) {
    errors.date = "Select holiday Date *";
    isError = true;
  }
  return { errors, isError };
};

// validate globle setting data
export const validateGlobalSettingData = (inputDetail: any) => {
  let isError = false;
  const errors: any = {};

  if (window.cn(inputDetail.slot_count_per_day) && !window.cb(inputDetail.slot_count_per_day)) {
    errors.slot_count_per_day = "Enter slot count per day *";
    isError = true;
  }

  if (window.cn(inputDetail.no_of_days_enable) && !window.cb(inputDetail.no_of_days_enable)) {
    errors.no_of_days_enable = "Enter number of days to enable *";
    isError = true;
  }

  if (window.cn(inputDetail.tax_filing_start_date) && !window.cb(inputDetail.tax_filing_start_date)) {
    errors.tax_filing_start_date = "Select Tax Filing Start Date *";
    isError = true;
  }

  return { errors, isError };
};

// validation for file select in document
// export const validateFileUpload = (selectedFile: any) => {
//   let isError = false;
//   let errors: any = {};

//   if (window.cn(selectedFile.file) && !window.cb(selectedFile.file)) {
//     errors.selectedFile = "Upload Document *";
//     isError = true;
//   }
//   return { errors, isError };
// };

// validate file upload
export const validateFileUpload = (selectedFile: any) => {
  let isError = false;
  let errors: any = {};

  if (window.cn(selectedFile) && !window.cb(selectedFile)) {
    errors.selectedFile = "Document is required *";
    isError = true;
  }

  return { errors, isError };
};

// .................................................. validate file upload for tax payer reading doc & upload doc ......................
export const validateSignAndReadingFileUpload = (
  selectedFile: any,
  readingFileSelected: any,
  spouseFile?: any,
  spouseReadingFileSelected?: any,
  isSpouseRequired?: boolean
) => {
  let isError = false;
  let errors: any = {};

  if (window.cn(selectedFile) && !window.cb(selectedFile)) {
    errors.selectedFile = "Document is required *";
    isError = true;
  }

  if (window.cn(readingFileSelected) && !window.cb(readingFileSelected)) {
    errors.readingFileSelected = "Document is required *";
    isError = true;
  }

  if (isSpouseRequired) {
    if (window.cn(spouseFile) && !window.cb(spouseFile)) {
      errors.spouseFile = "Document is required *";
      isError = true;
    }
    if (window.cn(spouseReadingFileSelected) && !window.cb(spouseReadingFileSelected)) {
      errors.spouseReadingFileSelected = "Document is required *";
      isError = true;
    }
  }

  return { errors, isError };
};

export const validateResendBalanceAmount = (balanceAmount: any) => {
  let isError = false;
  let errors: any = {};

  if (window.cn(balanceAmount) && !window.cb(balanceAmount)) {
    errors.balanceAmount = "Balance Amount is required *";
    isError = true;
  }

  return { errors, isError };
};

// ..................................... validate sin number password .................................
export const validatePasswordField = (password: any) => {
  let errors: any = {};
  let isError = false;

  // if empty or null
  if (window.cn(password) && !window.cb(password)) {
    errors.password = "Enter Password *";
    isError = true;
  }

  return { errors, isError };
};

// ................................... validate tax filing dates .....................................
export const validateTaxFillingDates = (taxFillingDates: any) => {
  let errors: any = {};
  let isError = false;

  // if empty or null
  if (window.cn(taxFillingDates) && !window.cb(taxFillingDates)) {
    errors.date = "Enter date *";
    isError = true;
  }

  return { errors, isError };
};

// ................................... validate email ............ tax payer list ..................

export const validateEditEmail = (inputDetail: any) => {
  let errors: any = {};
  let isError = false;

  // validate email
  if (window.cn(inputDetail?.email) && !window.cb(inputDetail?.email)) {
    errors.email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail?.email)) {
    errors.email = "Enter Valid Email *";
    isError = true;
  }

  return { errors, isError };
};

// company add/edit validate
export const validateCompanyForm = (inputDetail: any) => {
  let errors: any = {};
  let isError = false;

  if (window.cn(inputDetail.company_name) && !window.cb(inputDetail.company_name)) {
    errors.company_name = "Enter Company Name *";
    isError = true;
  }

  if (window.cn(inputDetail.email) && !window.cb(inputDetail.email)) {
    errors.email = "Enter Email *";
    isError = true;
  } else if (!emailPattern.test(inputDetail.email)) {
    errors.email = "Enter Valid Email *";
    isError = true;
  }

  if (window.cn(inputDetail.mobile_no) && !window.cb(inputDetail.mobile_no)) {
    errors.mobile_no = "Enter Mobile Number *";
    isError = true;
  } else if (!phonePattern.test(inputDetail.mobile_no)) {
    errors.mobile_no = "Enter Valid Mobile Number *";
    isError = true;
  }

  if (window.cn(inputDetail.business_no) && !window.cb(inputDetail.business_no)) {
    errors.business_no = "Enter Business Number *";
    isError = true;
  }

  return { errors, isError };
};

// ................................... validate company T183 upload .....................................
export const validateCompanyT183Upload = (
  selectedFile: any,
  profitAndLossFile: any,
  balanceSheetFile: any
) => {
  let isError = false;
  let errors: any = {};

  if (window.cn(selectedFile) && !window.cb(selectedFile)) {
    errors.selectedFile = "Document is required *";
    isError = true;
  }

  if (window.cn(profitAndLossFile) && !window.cb(profitAndLossFile)) {
    errors.profitAndLossFile = "Document is required *";
    isError = true;
  }

  if (window.cn(balanceSheetFile) && !window.cb(balanceSheetFile)) {
    errors.balanceSheetFile = "Document is required *";
    isError = true;
  }

  return { errors, isError };
};
